<div *ngIf="isShow">
  <div class="cartPreview" [ngClass]="{hasLoader: pending}">
    <div *ngIf="hasItems">
      <vc-floating-cart-product-list
        [orderLines]="currentCart['orderLines']"
        (onRemoveProduct)="onRemoveProduct($event)"
        (onClosePreviewBox)="onClosePreviewBox($event)"
      >
      </vc-floating-cart-product-list>
      <vc-floating-cart-price [currentCart]="currentCart"></vc-floating-cart-price>
      <a
        *ngIf="!useNewCheckout"
        i18n-routerLink="@@HEADER.FLOATING_CART.SEE_ORDER.LINK"
        routerLink="/shop-order.shtml"
        class="vc-btn vc-btn--primary vc-btn--large vc-btn--full"
        [ngClass]="{hasLoader: loadingCheckout}"
        (click)="launchLoader()"
        i18n="@@HEADER.FLOATING_CART.SEE_ORDER.LABEL"
        >Proceed to checkout</a
      >
      <a
        *ngIf="useNewCheckout"
        [href]="checkoutUrl"
        class="vc-btn vc-btn--primary vc-btn--large vc-btn--full"
        (click)="closeBeforeRelocate($event)"
        i18n="@@HEADER.FLOATING_CART.SEE_ORDER.LABEL"
        >Proceed to checkout</a
      >
      <a
        *ngIf="!useNewCheckout"
        i18n-routerLink="@@HEADER.FLOATING_CART.SEE_CART.LINK"
        routerLink="/shop-cart.shtml"
        class="cartPreview__seeMyBag"
        i18n="@@HEADER.FLOATING_CART.SEE_CART.LABEL"
        >View my shopping bag</a
      >
      <a
        *ngIf="useNewCheckout"
        [href]="newCartUrl"
        class="cartPreview__seeMyBag"
        i18n="@@HEADER.FLOATING_CART.SEE_CART.LABEL"
        (click)="closeBeforeRelocate($event)"
        >View my shopping bag</a
      >
    </div>
    <div class="cartPreview__empty" *ngIf="!hasItems">
      <vc-sprite-icons class="cartPreview__empty__icon" name="bag"></vc-sprite-icons>
      <ng-container i18n="@@HEADER.FLOATING_CART.EMPTY_CART"
        >Your shopping bag is currently empty... but not for long!</ng-container
      >
    </div>
  </div>
</div>
